import styles from './content-text.module.scss';
export default function ContentText(props) {
  return (
    <div className={styles['main-content-text']}>
      <div data-aos="fade-up" data-aos-duration="2000">
        <h1>{props.title}</h1>

        <p>{props.content}</p>
      </div>
      <div data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
        <div
          className={styles['learn-more']}
          onClick={props.btnCallback ? () => props.btnCallback() : ''}
        >
          {props.btnText}
        </div>
      </div>
    </div>
  );
}
